import ReactDOM from "react-dom/client";
import App from "./app";
import "./assets/stylesheets/index.css";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://a793e96c84c8950712359a45f9abc604@o4508088678809600.ingest.de.sentry.io/4508930704867408",
  integrations: [],
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
